import './Flame.css';
export var scrollContainer = '_tmtjo80-3-15-1';